export default "__VITE_ASSET__RvbxGWnf__"